import { simulateCartPrice } from '../services/pricing';
import { getListOfCartItemIds } from '../components/helpers';

export const SET_CART_LOADING = 'CART_LOADING';
export const ADD_CART_ITEM = 'ADD_CART_ITEM';
export const MODIFY_ITEM_QUANTITY = 'MODIFY_ITEM_QUANTITY';
export const VALIDATE_CART = 'VALIDATE_CART';
export const UPDATE_CART = 'UPDATE_CART';
export const SET_CART_ERROR = 'SET_CART_ERROR';

export const validateCartAction = () => ({
  type: VALIDATE_CART,
});

export const addCartItem = id => ({
  type: ADD_CART_ITEM,
  id,
});

export const modifyItemQuantity = (id, quantity) => ({
  type: MODIFY_ITEM_QUANTITY,
  id,
  quantity,
});

export const updateCart = cartData => ({
  type: UPDATE_CART,
  cartData,
});

export const setCartLoading = () => ({
  type: SET_CART_LOADING,
});

export const setCartError = error => ({
  type: SET_CART_ERROR,
  error,
});

const getCartDataFromWarehouse = (itemQuantitiesById, allProducts) => {
  const items = Object.entries(itemQuantitiesById).map(([id, quantity]) => {
    const { name, price, quantity: availableStock } = allProducts.find(p => p.id === Number(id));
    const { amount } = price;
    return {
      id,
      name,
      total: {
        price: amount * quantity,
        quantity,
      },
      default: {
        price: amount,
        quantity,
      },
      availableStock,
      subsidies: [],
    };
  });

  const totalPrice = items.reduce((acc, curr) => acc + curr.total.price, 0);
  return { items, totalPrice, transactionRules: [] };
};

export const evaluateCartPrice = () => async (dispatch, getState) => {
  const state = getState();
  const { clientId } = state.client;
  const { itemQuantitiesById } = state.cart;
  const { currentMenu } = state.warehouse;
  const allProducts = currentMenu
    ? currentMenu.categories.flatMap(category => category.products)
    : [];

  if (clientId === -1) {
    const cartData = getCartDataFromWarehouse(itemQuantitiesById, allProducts);
    dispatch(updateCart(cartData));
    return;
  }
  try {
    dispatch(setCartLoading());
    const itemIds = getListOfCartItemIds(itemQuantitiesById);

    const priceDetails = await simulateCartPrice(clientId, itemIds);

    const quantityAwareItems = priceDetails.items.map(item => {
      const { quantity } = allProducts.find(p => p.id === Number(item.id));
      return {
        ...item,
        availableStock: quantity,
      };
    });

    dispatch(updateCart({ ...priceDetails, items: quantityAwareItems }));
  } catch (error) {
    dispatch(setCartError(error.toString()));
  }
};
